import './BundleMsgAttach.sass';

import React, { FC, useState } from 'react';
import { Button } from '$uikit';
import { BundleMsgAttachProps } from './BundleMsgAttach.interface';
import { MediaViewer } from '$shared/components/MediaViewer/MediaViewer';

export const BundleMsgAttach: FC<BundleMsgAttachProps> = ({ bundle, attachments }) => {
  const [showViewer, setShowViewer] = useState(false);

  return (
    <div className="BundleMsgAttach">
      <MediaViewer
        active={showViewer}
        attachments={attachments}
        onClose={() => setShowViewer(false)}
      />
      <div className="BundleMsgAttach__name">{bundle.bundle.name}</div>
      <div className="BundleMsgAttach__description">{bundle.bundle.description}</div>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setShowViewer(true);
          // showModal('bundle' + bundle.bundle.id);
        }}
        size="medium"
      >
        View bundle content
      </Button>
    </div>
  );
};
